const base64ToArrayBuffer = (base64: string) => {
  try {
    const binaryString = atob(base64); // Base64 디코딩
    const len = binaryString.length;
    const bytes = new Uint8Array(len); // Uint8Array로 변환

    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer; // ArrayBuffer 반환
  } catch (e) {
    console.error('Error decoding Base64 to ArrayBuffer:', e);
    return null;
  }
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  try {
    const bytes = new Uint8Array(buffer);
    let binary = '';

    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  } catch (e) {
    console.error('Error decoding ArrayBuffer to Base64:', e);
    return null;
  }
};

const importPublicKey = async (
  publicKeyBuffer: ArrayBuffer
): Promise<CryptoKey | null> => {
  try {
    const publicKey = await crypto.subtle.importKey(
      'spki',
      publicKeyBuffer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      true,
      ['encrypt']
    );

    return publicKey;
  } catch (error) {
    console.error('Error importing public key:', error);
    return null;
  }
};

const encryptData = async (
  input: string,
  publicKey: CryptoKey
): Promise<ArrayBuffer | null> => {
  try {
    const encodedData = new TextEncoder().encode(input);

    const encryptedData = await crypto.subtle.encrypt(
      {name: 'RSA-OAEP'},
      publicKey,
      encodedData
    );

    return encryptedData;
  } catch (error) {
    console.error('Error during encryption:', error);
    return null;
  }
};

export const encryptRSA = async (input: string) => {
  if (!input) {
    return null;
  }

  // publicKey 가져오기
  const publicKeyBase64 = `${process.env.REACT_APP_CRYPTO_PUBLIC_KEY_BASE64}`;
  const publicKeyBuffer = base64ToArrayBuffer(publicKeyBase64);

  if (!publicKeyBuffer) {
    return null;
  }

  const publicKey = await importPublicKey(publicKeyBuffer);

  if (!publicKey) {
    return null;
  }

  // 암호화
  const encryptedBuffer = await encryptData(input, publicKey);

  if (!encryptedBuffer) {
    return null;
  }

  const encryptedBase64 = arrayBufferToBase64(encryptedBuffer);

  return encryptedBase64;
};
